import React, { Component } from 'react';
import styled from 'styled-components';

import Input from '../../components/Input';
import ChipInput from '../../components/ChipInput';
import JsonLogicBuilder from '../../components/JsonLogicBuilder';
import Notification from '../../components/Notification';

import {getLogicBuilderVariables} from './shared';
import DeletableCard from './DeletableCard';
import SubConfiguration from './SubConfiguration';
import { areShallowEqual } from '../../lib/helpers';
import { Checkbox } from './QuestionBuilder';
import Icon from "../../components/Icon";
import Menu from "../../components/Menu";
import Button from "../../components/Button";

class AlertBuilder extends Component {

  state = {
    optionsOpen: false
  };

  shouldComponentUpdate(prevProps, prevState) {
    const {alert, validations} = this.props;

    if (prevState !== this.state) {
      // Always update when the local state changes.
      return true;
    }

    if (prevProps.alert !== alert) {
      // Always update when the alert changes.
      return true;
    }

    if (!areShallowEqual(prevProps.validations, validations)) {
      // Always update when the validations have changed.
      return true;
    }

    return false;
  }

  setAlertState = reducer => {
    const {alert, onChange} = this.props;

    onChange({
      ...alert,
      ...(typeof reducer === 'function' ? reducer(alert) : reducer)
    });
  }

  handleDeleteAlert = () => {
    const {alert, onRemove} = this.props;
    onRemove(alert);
  }

  handleCopyAlert = () => {
    const {alert, onCopy} = this.props;
    onCopy({...alert, name: `Copy of ${alert.name}`});
  }

  handleAlertNameChanged = e => {
    const {alert} = this.props;

    if (alert.name !== e.target.value) {
      this.setAlertState({name: e.target.value});
    }
  }

  handleContactsChanged = alertContacts => {
    this.setAlertState({alertContacts});
  }

  handleExpressionChanged = expression => {
    this.setAlertState({expression: JSON.stringify(expression)});
  }

  setIsMobileAlertChecked() {
    const { alert } = this.props;
    this.setAlertState({mobileAlert: !alert.mobileAlert});
  }

  toggleAlertOptions = () => {
    this.setState(prevState => ({
      optionsOpen: !prevState.optionsOpen
    }));
  }

  render() {
    const {form, catalog, users, alert, validations, } = this.props;
    const { optionsOpen } = this.state;

    return (
      <DeletableCard
        focusable
        dialogTitle="Delete this alert?"
        dialogDescription="Are you sure you want to delete this alert? This cannot be undone."
        ok="Delete"
        onOk={this.handleDeleteAlert}>
        <AlertForm>
          <TopContainer>
            <Input
              id={`alert_title_${alert.id}`}
              label="Alert name"
              placeholder="Enter a short name for this alert"
              defaultValue={alert.name}
              onBlur={this.handleAlertNameChanged}
              invalid={validations.name}
              validationText={validations.name}
            />
            <ButtonContainer>
              <AlertOptionsButton id={`alert-options-${alert.id}`} tertiary onClick={this.toggleAlertOptions}>
                <Icon name="chevron-down" />
              </AlertOptionsButton>
              <Menu open={optionsOpen} relativeTo={`alert-options-${alert.id}`} onClose={this.toggleAlertOptions}>
                <Menu.Option onClick={() => this.handleCopyAlert()}>Copy alert</Menu.Option>
              </Menu>
            </ButtonContainer>
          </TopContainer>
          <ChipInput
            id={`alert_contacts_${alert.id}`}
            label="Alert contacts"
            placeholder="Choose who to notify when this alert is triggered"
            value={alert.alertContacts}
            suggestions={users}
            onChange={this.handleContactsChanged}
          />
          {validations.expression && (
            <Notification mini error>{validations.expression}</Notification>
          )}
          <Condition>
            <label>Trigger this alert when...</label>
            <SubConfiguration>
              <SubConfiguration.Item>
                <JsonLogicBuilder
                  expand
                  variables={getLogicBuilderVariables(form, catalog)}
                  value={JSON.parse(alert.expression)}
                  onChange={this.handleExpressionChanged}
                />
              </SubConfiguration.Item>
            </SubConfiguration>
          </Condition>
            <Checkbox> 
              <input
                disabled={false}
                type="checkbox"
                checked={alert.mobileAlert}
                onChange={e => this.setIsMobileAlertChecked()}
              />
              &nbsp;
              Notify Mobile User
            </Checkbox>
        </AlertForm>
      </DeletableCard>
    );
  }
}

const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;

  > :first-child {
    flex: 3; // Gives more space to the first child so the name input extends
  }
`;

const ButtonContainer = styled.div`
  max-width: 10px;
  max-height: 10px;
  margin-right: 2rem;
`;


const AlertOptionsButton = styled(Button)`
  margin-right: -1rem;
  margin-left: 1rem;
`;

const AlertForm = styled.div`
  > * {
    margin-bottom: 1.5rem;

    :last-child {
      margin-bottom: 0;
    }
  }
`;

const Condition = styled.div`
  label {
    display: block;
    margin-bottom: 0.5rem;
  }
`;

export default AlertBuilder;